import { render, staticRenderFns } from "./ClienteBI.vue?vue&type=template&id=007136f1&"
import script from "./ClienteBI.vue?vue&type=script&lang=js&"
export * from "./ClienteBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports